import React from 'react';

export const TextInput = ({ label, name, value, onChange, type = 'text', placeholder = '', required = false, className = '' }) => (
  <div className={`space-y-1 ${className}`}>
    {label && <label htmlFor={name} className="block text-sm font-medium text-slate-700">{label}</label>}
    <input
      id={name}
      name={name}
      type={type}
      value={value}
      placeholder={placeholder}
      required={required}
      onChange={onChange}
      className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    />
  </div>
);

export const SelectInput = ({ label, name, value, onChange, options, required = false, className = '' }) => (
  <div className={`space-y-1 ${className}`}>
    {label && <label htmlFor={name} className="block text-sm font-medium text-slate-700">{label}</label>}
    <select
      id={name}
      name={name}
      value={value}
      required={required}
      onChange={onChange}
      className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-700 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    >
      {options.map((opt) => (
        <option key={opt.value ?? opt} value={opt.value ?? opt}>
          {opt.label ?? opt}
        </option>
      ))}
    </select>
  </div>
);

export const TextArea = ({ label, name, value, onChange, placeholder = '', required = false, rows = 4, className = '' }) => (
  <div className={`space-y-1 ${className}`}>
    {label && <label htmlFor={name} className="block text-sm font-medium text-slate-700">{label}</label>}
    <textarea
      id={name}
      name={name}
      value={value}
      placeholder={placeholder}
      required={required}
      rows={rows}
      onChange={onChange}
      className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    />
  </div>
);

export const PrimaryButton = ({ children, onClick, type = 'button', className = '' }) => (
  <button
    type={type}
    onClick={onClick}
    className={`rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 font-semibold shadow hover:shadow-lg transition ${className}`}
  >
    {children}
  </button>
);
